import React from 'react';
import './systemintegration.css'


function systemintegration () {
   
        return (
            <div>
                <div className="container-fluid">

    <div className="row justify-content-center">

        {/* <!-- COL-SM-10 --> */}
        <div className="">

            <div className="integrationPageWrapper">

                <div className="integrationPageContainer">

                    {/* <!-- HEADER --> */}
                    <div className="integrationHeaderWrapper">

                        <div className="integrationTitleContainer">

                            <div className="integrationMainTitle">
                                Tích hợp hệ thống
                            </div>

                            <div className="integrationBreadcrumbText">
                                Trang chủ / Tích hợp hệ thống
                            </div>

                        </div>

                        <button className="integrationCreateButton">
                            ＋ Thêm cấu hình tích hợp
                        </button>

                    </div>

                    {/* <!-- SEARCH --> */}
                    <div className="integrationSearchSection">

                        <div className="integrationSearchTitle">
                            Tìm kiếm
                        </div>

                        <div className="row integrationSearchRow">

                            {/* <!-- NAME --> */}
                            <div className="col-md-3 integrationSearchGroup">

                                <label className="integrationSearchLabel">
                                    Tên hệ thống
                                </label>

                                <div className="integrationInputWrapper">

                                    <input
                                        type="text"
                                        className="integrationInputField"
                                        placeholder="Nhập tên hệ thống..."
                                    />

                                    <div className="integrationInputIcon">
                                        <i className="fa-solid fa-magnifying-glass"></i>
                                    </div>

                                </div>

                            </div>

                            {/* <!-- STATUS --> */}
                            <div className="col-md-2 integration-search-group-status">

                                <label className="integrationSearchLabel">
                                    Trạng thái
                                </label>

                                <select className="integrationSelectField">
                                    <option>-- Tất cả --</option>
                                </select>

                            </div>

                            {/* <!-- TYPE --> */}
                            <div className="col-md-2 integration-search-group-type">

                                <label className="integrationSearchLabel">
                                    Loại tích hợp
                                </label>

                                <select className="integrationSelectField">
                                    <option>-- Tất cả --</option>
                                </select>

                            </div>

                            {/* <!-- PROTOCOL --> */}
                            <div className="col-md-2 integration-search-group-protocol">

                                <label className="integrationSearchLabel">
                                    Giao thức
                                </label>

                                <select className="integrationSelectField">
                                    <option>-- Tất cả --</option>
                                </select>

                            </div>

                            {/* <!-- BUTTON --> */}
                            <div className="col-md-3 integration-search-group-btn">

                                <div className="integrationSearchButtonWrapper">

                                    <button className="integrationResetButton">
                                        ↻ Đặt lại
                                    </button>

                                    <button className="integrationSearchButton">
                                        🔍 Tìm kiếm
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                    {/* <!-- TABLE --> */}
                    <div className="integrationTableSection">

                        <div className="integrationTableHeader">

                            <div className="integrationTableTitle">
                                Danh sách tích hợp hệ thống
                            </div>

                            <div className="integrationTableActionWrapper">

                                <button className="integrationTestButton">
                                  <i className="fa-solid fa-wifi icon-wifi"></i>
                                    Test kết nối
                                </button>

                                <button className="integrationRefreshButton">
                                    ↻ Làm mới
                                </button>

                                <button className="integrationSettingButton">
                                    ⚙
                                </button>

                            </div>

                        </div>

                        {/* <!-- TABLE --> */}
                        <div className="integrationTableWrapper">

                            <table className="integrationDataTable">

                                <thead className="integrationTableHead">

                                    <tr className="integrationTableHeadRow">

                                        <th className="integrationTableHeadCell">STT</th>
                                        <th className="integrationTableHeadCell">Tên hệ thống</th>
                                        <th className="integrationTableHeadCell">Loại tích hợp</th>
                                        <th className="integrationTableHeadCell">Giao thức</th>
                                        <th className="integrationTableHeadCell">Endpoint</th>
                                        <th className="integrationTableHeadCell">Trạng thái</th>
                                        <th className="integrationTableHeadCell">Người cập nhật</th>
                                        <th className="integrationTableHeadCell">Cập nhật lần cuối</th>
                                        <th className="integrationTableHeadCell">Thao tác</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr className="integrationTableBodyRow">

                                        <td className="integrationTableBodyCell">1</td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationSystemInfoWrapper">

                                                {/* <div className="integrationSystemIcon integrationIconRed">
                                                    🔥
                                                </div> */}

                                                <div>
                                                    Hệ thống một cửa điện tử tỉnh An Giang (iGOSP)
                                                </div>

                                            </div>

                                        </td>

                                        <td className="integrationTableBodyCell">
                                            REST API
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            HTTPS
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            https://motcua.angiang.gov.vn/api
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            <span className="integrationConnectedStatus">
                                                Đã kết nối
                                            </span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            admin
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            20/05/2024 14:30:15
                                        </td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationActionIconWrapper">

                                                <i className="fa-regular fa-pen-to-square integrationEditIcon"></i>

                                               <i className="fa-solid fa-gear"></i>

                                                <i className="fa-regular fa-trash-can integrationDeleteIcon"></i>

                                            </div>

                                        </td>

                                    </tr>

                                    <tr className="integrationTableBodyRow">

                                        <td className="integrationTableBodyCell">2</td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationSystemInfoWrapper">

                                                {/* <div className="integrationSystemIcon integrationIconBlue">
                                                    🛡
                                                </div> */}

                                                <div>
                                                    Hệ thống xác thực tập trung (VNPT-SSO)
                                                </div>

                                            </div>

                                        </td>

                                        <td className="integrationTableBodyCell">
                                            REST API
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            HTTPS
                                        </td>

                                        <td className="integrationTableBodyCell">
                                          
                                           https://sso.angiang.gov.vn/api/auth
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            <span className="integrationConnectedStatus">
                                                Đã kết nối
                                            </span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            admin
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            20/05/2024 10:15:22
                                        </td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationActionIconWrapper">

                                                <i className="fa-regular fa-pen-to-square integrationEditIcon"></i>

                                               <i className="fa-solid fa-gear"></i>

                                                <i className="fa-regular fa-trash-can integrationDeleteIcon"></i>

                                            </div>

                                        </td>

                                    </tr>

                                    <tr className="integrationTableBodyRow">

                                        <td className="integrationTableBodyCell">3</td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationSystemInfoWrapper">

                                                {/* <div className="integrationSystemIcon integrationIconGreen">
                                                    🌐
                                                </div> */}

                                                <div>
                                                    Cổng dịch vụ công Quốc gia (DVCQG)
                                                </div>

                                            </div>

                                        </td>

                                        <td className="integrationTableBodyCell">
                                            REST API
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            HTTPS
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            https://api.dichvucong.gov.vn/
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            <span className="integrationConnectedStatus">
                                                Đã kết nối
                                            </span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            lethicuc
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            19/05/2024 16:45:10
                                        </td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationActionIconWrapper">

                                                <i className="fa-regular fa-pen-to-square integrationEditIcon"></i>

                                               <i className="fa-solid fa-gear"></i>

                                                <i className="fa-regular fa-trash-can integrationDeleteIcon"></i>

                                            </div>

                                        </td>

                                    </tr>

                                    <tr className="integrationTableBodyRow">

                                        <td className="integrationTableBodyCell">4</td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationSystemInfoWrapper">

                                                {/* <div className="integrationSystemIcon integrationIconDarkBlue">
                                                    🏛
                                                </div> */}

                                                <div>
                                                    Hệ thống thông tin báo cáo Chính phủ (BC-CP)
                                                </div>

                                            </div>

                                        </td>

                                        <td className="integrationTableBodyCell">
                                            REST API
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            HTTPS
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            https://api.baocaohinhphu.gov.vn/
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            <span className="integrationConnectedStatus">
                                                Đã kết nối
                                            </span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            admin
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            18/05/2024 09:20:05
                                        </td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationActionIconWrapper">

                                                <i className="fa-regular fa-pen-to-square integrationEditIcon"></i>

                                               <i className="fa-solid fa-gear"></i>

                                                <i className="fa-regular fa-trash-can integrationDeleteIcon"></i>

                                            </div>

                                        </td>

                                    </tr>

                                    <tr className="integrationTableBodyRow">

                                        <td className="integrationTableBodyCell">5</td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationSystemInfoWrapper">

                                                {/* <div className="integrationSystemIcon integrationIconYellow">
                                                    ✉
                                                </div> */}

                                                <div>
                                                    Hệ thống gửi nhận Email (EMAIL-SERVICE)
                                                </div>

                                            </div>

                                        </td>

                                        <td className="integrationTableBodyCell">
                                            SMTP
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            SMTP (TLS)
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            smtp.angiang.gov.vn:587
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            <span className="integrationConnectedStatus">
                                                Đã kết nối
                                            </span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            nguyenvana
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            18/05/2024 08:30:12
                                        </td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationActionIconWrapper">

                                                <i className="fa-regular fa-pen-to-square integrationEditIcon"></i>

                                                <i className="fa-solid fa-gear"></i>

                                                <i className="fa-regular fa-trash-can integrationDeleteIcon"></i>

                                            </div>

                                        </td>

                                    </tr>

                                    <tr className="integrationTableBodyRow">

                                        <td className="integrationTableBodyCell">6</td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationSystemInfoWrapper">

                                                {/* <div className="integrationSystemIcon integrationIconPurple">
                                                    🗄
                                                </div> */}

                                                <div>
                                                    Cơ sở dữ liệu chuyên ngành (CSDL-CN)
                                                </div>

                                            </div>

                                        </td>

                                        <td className="integrationTableBodyCell">
                                            JDBC
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            TCP/IP
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            jdbc:sqlserver://10.10.10.20:1433;databaseName=cn
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            <span className="integrationDisconnectedStatus">
                                                Lỗi kết nối
                                            </span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            admin
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            20/05/2024 08:10:33
                                        </td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationActionIconWrapper">

                                                <i className="fa-regular fa-pen-to-square integrationEditIcon"></i>

                                                <i className="fa-solid fa-gear"></i>

                                                <i className="fa-regular fa-trash-can integrationDeleteIcon"></i>

                                            </div>

                                        </td>

                                    </tr>

                                    <tr className="integrationTableBodyRow">

                                        <td className="integrationTableBodyCell">7</td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationSystemInfoWrapper">

                                                {/* <div className="integrationSystemIcon integrationIconOrange">
                                                    ☀
                                                </div> */}

                                                <div>
                                                    Hệ thống Thuế điện tử (THUE-API)
                                                </div>

                                            </div>

                                        </td>

                                        <td className="integrationTableBodyCell">
                                            REST API
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            HTTPS
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            https://thuedientu.gdt.gov.vn/api
                                        </td>

                                        <td className="integrationTableBodyCell">
                                            <span className="integrationNotConfigStatus">
                                                Chưa cấu hình
                                            </span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                           <span className='hyphen'>-</span>
                                        </td>

                                        <td className="integrationTableBodyCell">
                                             <span className='hyphen'>-</span>
                                        </td>

                                        <td className="integrationTableBodyCell">

                                            <div className="integrationActionIconWrapper">

                                                <i className="fa-regular fa-pen-to-square integrationEditIcon"></i>

                                                <i className="fa-solid fa-gear"></i>

                                                <i className="fa-regular fa-trash-can integrationDeleteIcon"></i>

                                            </div>

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                        {/* <!-- PAGINATION --> */}
                        <div className="integrationPaginationContainer">

                            <div className="integrationPaginationLeft">

                                <div className="integrationPaginationText">
                                    Hiển thị
                                </div>

                                <select className="integrationPaginationSelect">
                                    <option>10</option>
                                </select>

                                <div className="integrationPaginationText">
                                    dòng trên mỗi trang
                                </div>

                            </div>

                            <div className="integrationPaginationRight">
                                <div className='one-seven'>
                                    1 - 7 trong 7
                                </div>

                                <button className="integrationPaginationButton">
                                    «
                                </button>

                                <button className="integrationPaginationButton">
                                    ‹
                                </button>

                                <button className="integrationPaginationButtonActive">
                                    1
                                </button>

                                <button className="integrationPaginationButton">
                                    ›
                                </button>

                                <button className="integrationPaginationButton">
                                    »
                                </button>

                            </div>

                        </div>

                    </div>

                    {/* <!-- BOTTOM --> */}
                    <div className="integrationBottomSection">

                        <div className="row">

                            {/* <!-- CHART --> */}
                            <div className="col-md-4 circle-one">

                                <div className="integration-bottom-card-left">

                                    <div className="integrationBottomCardTitle">
                                        Thống kê kết nối
                                    </div>

                                    <div className="integrationCircleWrapper">

                                        <div className="integrationCircleChart">

                                            <div className="integrationCircleCenter">

                                                <div className="integrationCircleNumber">
                                                    7
                                                </div>

                                                <div className="integrationCircleText">
                                                    Tổng số
                                                </div>

                                            </div>

                                        </div>

                                        <div className='content-show'>

                                            <div className="integrationLegendItem">

                                                <div className="integrationLegendGreen"></div>

                                                <div className="integrationLegendText">
                                                    Đã kết nối 5 (71.43%)
                                                </div>

                                            </div>

                                            <div className="integrationLegendItem">

                                                <div className="integrationLegendRed"></div>

                                                <div className="integrationLegendText">
                                                    Lỗi kết nối 1 (14.29%)
                                                </div>

                                            </div>

                                            <div className="integrationLegendItem">

                                                <div className="integrationLegendGray"></div>

                                                <div className="integrationLegendText">
                                                    Chưa cấu hình 1 (14.29%)
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            {/* <!-- QUICK CHECK --> */}
                            <div className="col-md-4 circle-middle">

                                <div className="integrationBottomCard">

                                    <div className="integrationBottomCardTitle">
                                        Kiểm tra kết nối nhanh
                                    </div>

                                    <select className="integrationQuickSelect">
                                        <option>Chọn hệ thống cần kiểm tra</option>
                                    </select>

                                    <button className="integrationQuickButton">
                                        <i className="fa-solid fa-wifi icon-wifi-chek"></i>
                                         Kiểm tra
                                    </button>

                                    <div className="integrationQuickResult">
                                        Kết quả kiểm tra sẽ hiển thị ở đây.
                                    </div>

                                </div>

                            </div>

                            {/* <!-- LOG --> */}
                            <div className="col-md-4 circle-right">

                                <div className="integrationBottomCard">

                                    <div className="integrationBottomCardTitle">
                                        Nhật ký tích hợp gần đây
                                    </div>

                                    <div className="integrationLogItem">

                                        <div className="integrationLogDot"></div>

                                        <div className="integrationLogText">
                                            20/05/2024 14:30:15 - Kết nối thành công với iGOSP
                                        </div>

                                    </div>

                                    <div className="integrationLogItem">

                                        <div className="integration-log-dot"></div>

                                        <div className="integrationLogText">
                                            20/05/2024 08:10:33 - Không thể kết nối đến CSDL-CN
                                        </div>

                                    </div>

                                    <div className="integrationLogItem">

                                        <div className="integrationLogDot"></div>

                                        <div className="integrationLogText">
                                            19/05/2024 16:45:10 - Kết nối thành công với DVCQG
                                        </div>

                                    </div>

                                    <div className="integrationLogItem">

                                        <div className="integrationLogDot"></div>

                                        <div className="integrationLogText">
                                            18/05/2024 09:20:05 - Kết nối thành công với BC-CP
                                        </div>

                                    </div>

                                    <div className="integrationLogItem">

                                        <div className="integrationLogDot"></div>

                                        <div className="integrationLogText">
                                            18/05/2024 08:30:12 - Kết nối thành công với EMAIL-SERVICE
                                        </div>

                                    </div>

                                    <a
                                        href="#"
                                        className="integrationLogLink"
                                    >
                                        Xem tất cả nhật ký
                                    </a>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
            </div>
        );
    
}



export default systemintegration;